import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const productBadgeImageFragment = `
    on ${QueryType.product} {
        product_badge_image
    }
`;

export const productBadgeImageFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: productBadgeImageFragment
    };
};
